import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import rootReducer from './store/modules';
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { Provider } from 'react-redux';
import { toastTimer } from './middlewares/toastTimer';
// eslint-disable-next-line
import i18n from './config/lang/i18n';
import { openDocumentDialogClose } from './middlewares/openDocumentDialogClose';
import { handleEmptyAd } from './middlewares/handleEmptyAd';
import { init as gaInit } from './utils/gaConnect';
import { isProductionMode, isSupportOfflineMode } from './utils/util';
import registerServiceWorker from './registerServiceWorker';

const middlewares = [toastTimer, openDocumentDialogClose, handleEmptyAd]; // 미들웨어들을 넣으면 된다.
const genMiddlewareComposition = () => {
  return isProductionMode()
    ? applyMiddleware(...middlewares)
    : composeWithDevTools(applyMiddleware(...middlewares));
};

const store = createStore(rootReducer, genMiddlewareComposition()); // 스토어를 만듭니다.
gaInit();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

if ('serviceWorker' in navigator) {
  if (isSupportOfflineMode()) registerServiceWorker();
  else navigator.serviceWorker.register('/sw.js');
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
